import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from '@mui/material/DialogActions';
import Grid2 from '@mui/material/Grid2';
import FormControl from '@mui/material/FormControl';
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useSxStyles } from "../styles/sxStyles";
import Paper from '@mui/material/Paper';
import Typography from "@mui/material/Typography";
import Alert from '@mui/material/Alert';
import AlertTitle from "@mui/material/AlertTitle";
import ReplayIcon from "@mui/icons-material/Replay";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";

const Mfa = (props) => {
    const openMfa = props.openMfa;
    const setOpenMfa = props.setOpenMfa;
    const credentials = props.credentials;
    const mfaFields = props.mfaFields;
    const sendMfaCode = props.sendMfaCode;
    const codeSent = props.codeSent;
    const sendLogin = props.sendLogin;
    const [mfaCode, setMfaCode] = useState(null);
    const [enableLogin, setEnableLogin] = useState(false);
    const classes = useSxStyles;

    const canAuthenticate = (mfaFields) => {
        return mfaFields && mfaFields.email
    }

    const handleCodeChange = (e) => {
        const value = e.target.value;
        setMfaCode(`${value}`);
    }

    const sendMfaNotification = () => {
        const loginFields = credentials;
        loginFields.mfaMethod = 'email';
        sendMfaCode(loginFields);
    }

    const completeLogin = () => {
        const loginFields = credentials;
        loginFields.mfaCode = mfaCode;
        sendLogin(loginFields);
        setOpenMfa(false);
    }

    useEffect(() => {
        if (mfaCode && mfaCode.length > 5) {
            setEnableLogin(true);
        } else setEnableLogin(false);
    }, [mfaCode])

    return (
        (<Dialog
                open={openMfa}
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth='xs'
                sx={classes.dialog}
            >
            <DialogTitle>
                <Typography variant="h6" color='primary' sx={{textAlign: 'left'}}>
                    Complete Login
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    {canAuthenticate ?
                        <>
                            <Paper component={Grid2} spacing={1} justifyContent='center' elevation={3} sx={classes.controlPanel}>
                                <Alert severity='info' style={{textAlign: 'left'}}>
                                    { (codeSent || mfaFields.codeSent === true) ?
                                        'Enter the verification code you received by email within five minutes to finish logging in' :
                                        `Click the button below to email your verification code to ${mfaFields.email}`
                                    }
                                </Alert>
                                <Grid2 container spacing={2} alignItems="center">
                                    <Grid2 sx={classes.gridBottom} size={12}>
                                        <FormControl fullWidth>
                                            <FormLabel shrink={true} sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                                                Verification Code
                                            </FormLabel>
                                            <TextField
                                                name='code'
                                                variant='outlined'
                                                fullWidth
                                                onChange={handleCodeChange}
                                                slotProps={{
                                                    htmlInput: {sx: classes.textbox}
                                                }}
                                            />
                                        </FormControl>
                                    </Grid2>
                                </Grid2>
                            </Paper>
                        </> :
                        <Alert severity='error' style={{textAlign: 'left'}}>
                            <AlertTitle>Unable to Login</AlertTitle>
                            This system requires two-factor authentication, and your information does not include
                            a way to complete that. You must at least have an email address on record in order to log in.
                            Please contact your system administrator.
                        </Alert>
                    }
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Box display="inline">
                    <Button
                        variant='contained'
                        color='primary'
                        startIcon={<VerifiedUserOutlinedIcon/>}
                        disabled={!enableLogin}
                        sx={classes.button}
                        onClick={completeLogin}
                    >
                        Login
                    </Button>
                    { !codeSent && !mfaFields.codeSent &&
                        <Button
                            variant='contained'
                            color='primary'
                            startIcon={<SendOutlinedIcon/>}
                            sx={classes.button}
                            onClick={sendMfaNotification}
                        >
                            Send Code
                        </Button>
                    }
                    <Button variant="outlined"
                            color="primary"
                            startIcon={<ReplayIcon/>}
                            sx={classes.button}
                            onClick={() => {setOpenMfa(false)}}
                    >
                        Cancel
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>)
    );
}

export default Mfa;
